// http://doc.hunliji.com/workspace/myWorkspace.do?projectId=88#5126
export const M_STATUS_VERIFYING = 0
export const M_STATUS_SUCCESS = 1
export const M_STATUS_REJECTED = 3

// http://autotest.hunliji.com/#/project/-701335349/api/edit?apiId=203848&moduleid=2669&callback=%2523%2Fproject%2F-701335349%2Fapi%253Fmoduleid%253D2669
// 1：待审核,2:审核通过，3：审核失败
export const VIDEO_STATUS_VERIFYING = 1
export const VIDEO_STATUS_SUCCESS = 2
export const VIDEO_STATUS_REJECTED = 3
export const VIDEO_STATUS_PADDING = 1
export const VIDEO_STATUS_FAIL = 3
